let installPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  installPrompt = e;
  // Show your 'Install' button here
  document.querySelector('.custom-install-btn').style.display = 'block';
});

document.querySelector('.custom-install-btn').addEventListener('click', () => {
  installPrompt.prompt();
  installPrompt.userChoice.then((choice) => {
    if (choice.outcome === 'accepted') console.log('User installed PWA');
    installPrompt = null;
  });
});